import type { Birthday } from "@book-club/shared";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { membersKeys } from "@/features/members/queries/membersQueryKeys";
import membersService from "@/features/members/services/membersService";

export function useUpdateMemberBirthday(uid: string) {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (birthday: Birthday | null) => {
            await membersService.updateMemberBirthday(uid, birthday);
        },
        onError: (error) => {
            const errorMessage =
                error instanceof Error ? error.message : "Failed to update birthday. Please try again.";
            toast.error(errorMessage);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: membersKeys.detail(uid),
            });
            queryClient.invalidateQueries({
                queryKey: membersKeys.all,
            });
        },
    });

    return {
        error: mutation.error,
        isError: mutation.isError,
        isPending: mutation.isPending,
        mutate: mutation.mutate,
        mutateAsync: mutation.mutateAsync,
    };
}
